<template>
  <div style="width: 100%; margin: 10px auto;">
    <!--显示隐藏控制-->
    <el-checkbox-group v-show="pageData.isShow" v-model="checkList" style="margin: 20px auto">
      <el-checkbox :label="col.title" checked="checked" v-if="!col.click && !col.btnClick"
                   v-for="(col,index) in pageData.cols" :key="index"
      ></el-checkbox>
    </el-checkbox-group>

    <el-table border :key="this.tableKey" :data="tableData" style="width: 100%;margin-bottom: 10px" @selection-change="checkbox" :row-class-name="pageData.rowClassName" v-loading="loading">
      <!--多选-->
      <el-table-column :label="$t('page.selectAll')" v-if="pageData.selection" type="selection" :selectable="pageData.selectable"></el-table-column>
      <!--序号-->
      <el-table-column :label="$t('page.sort')" v-if="pageData.sequence" type="index" width="50px"></el-table-column>
      <el-table-column :show-overflow-tooltip="col.overflow !== undefined ? col.overflow : true"
                       :fixed="col.btnClick && col.btnClick.length > 0?'right':col.fixed"
                       :min-width="col.btnClick && col.btnClick.length > 0?col.minWidth||clientWidth/pageData.cols.length*(col.btnClick.length-1):col.minWidth||''"
                       v-if="(col.btnClick && col.btnClick.length > 0) || col.click || (!isShow[col.title] || isShow[col.title] != 'hide')"
                       v-for="(col,index) in pageData.cols" :key="index" :prop="col.field" :label="col.title"
                       :width="col.width"
      >
      
        <template slot-scope="scope">
          <el-tooltip  :content="getStatusText(col, scope.row)"  placement="top" v-if="col.stype === '100'">
            <el-switch 
              v-model="scope.row[col.field]"  
              v-if="col.stype === '100'"
              v-auth="col.auth"
              inactive-color="#cccccc"
              active-color="var(--brand-primary)"
              :active-value="1"
              :inactive-value="2"
              @change="btnclick(col,scope.row)"
              >
            </el-switch>
          </el-tooltip>

          <el-tooltip  :content="getStatusText(col, scope.row)"  placement="top" v-if="col.stype === '101'">
            <el-switch 
              v-model="scope.row[col.field]"  
              v-if="col.stype === '101'"
              v-auth="col.auth"
              inactive-color="#cccccc"
              active-color="var(--brand-primary)"
              :active-value="2"
              :inactive-value="1"
              @change="btnclick(col,scope.row)"
              >
            </el-switch>
          </el-tooltip>

          <div v-if="col.btnClick && col.btnClick.length > 0" style="text-align: center">
            <template v-for="(btn, index) in col.btnClick">
              <el-button 
                style="margin: 2px; display: inline-block"
                v-auth="btn.auth"
                :disabled="(typeof btn.disabled == 'function'?btn.disabled(scope.row[col.field],scope.row):btn.disabled)"
                :size="btn.size?btn.size:'mini'" :key="index"
                :type="typeof btn.type == 'function'?btn.type(scope.row[col.field],scope.row):btn.type"
                :icon="typeof btn.icon == 'function'?btn.icon(scope.row[col.field],scope.row):btn.icon"
                @click="btnclick(btn,scope.row)"
              >{{ typeof btn.name == 'function' ? btn.name(scope.row[col.field], scope.row) : btn.name }}</el-button>
              <br v-if="(index + 1) % 2 === 0 && index < col.btnClick.length - 1"
                style="content: ''; display: block; height: 5px"
              />
            </template>
          </div>
          <div v-else-if="!col.render">
            <div v-if="!col.click">
              <div v-if="col.h5Click === 'popup_up'" style="color: #0096dc;cursor: pointer;">
                <el-popover 
                placement="right"
                trigger="click">
                <div v-html="scope.row[col.field] ? scope.row[col.field].replace(/,/g,'<br>') : ''"></div>
                <span slot="reference">查看自选产品</span></el-popover>
              </div>
              <span
                v-if="col.h5Click && col.h5Click != 'popup_up' && (!col.h5ClickRender || (col.h5ClickRender && col.h5ClickRender(scope.row[col.field],scope.row)))"
                style="color: #0096dc;cursor: pointer;" @click="btnclick(col,scope.row)"
              >{{ scope.row[col.field] }}</span>
              <span
                v-if="!(col.h5Click && (!col.h5ClickRender ||  (col.h5ClickRender && col.h5ClickRender(scope.row[col.field],scope.row))))"
              >{{ scope.row[col.field] }}</span>
            </div>
            <el-button v-if="col.click" v-show="!(typeof col.hidden == 'function'?col.hidden(scope.row,col):col.hidden)"
                       v-auth="col.auth" @click="btnclick(col,scope.row)" :size="col.size?col.size:'mini'"
                       :disabled="(typeof col.disabled == 'function'?col.disabled(scope.row[col.field],scope.row):col.disabled)"
                       :type="typeof col.type == 'function'?col.type(scope.row[col.field],scope.row):col.type"
                       :icon="typeof col.icon == 'function'?col.icon(scope.row[col.field],scope.row):col.icon"
            >{{ col.field }}
            </el-button>
          </div>
          <div v-else-if="col.render">
            <div
              v-if="!col.click && col.h5Click && (!col.h5ClickRender || (col.h5ClickRender && col.h5ClickRender(scope.row[col.field],scope.row)))"
              style="color: #0096dc;cursor: pointer;" v-html="col.render(scope.row[col.field],scope.row)"
              @click="btnclick(col,scope.row)"
            ></div>
            <div
              v-if="!col.click && !(col.h5Click && (!col.h5ClickRender || (col.h5ClickRender && col.h5ClickRender(scope.row[col.field],scope.row))))"
              v-html="col.render(scope.row[col.field],scope.row)"
            ></div>
          
            <el-button v-if="col.click" v-show="!(typeof col.hidden == 'function'?col.hidden(scope.row,col):col.hidden)"
              v-auth="col.auth" :size="col.size?col.size:'mini'" @click="btnclick(col,scope.row)"
              :disabled="(typeof col.disabled == 'function'?col.disabled(scope.row[col.field],scope.row):col.disabled)"
              :type="typeof col.type == 'function'?col.type(scope.row[col.field],scope.row):col.type"
              :icon="typeof col.icon == 'function'?col.icon(scope.row[col.field],scope.row):col.icon"
            ></el-button>
          </div>
        </template>
      </el-table-column>
    </el-table>

    <el-pagination v-if="pageData.isPage == null || pageData.isPage"
                   @size-change="handleSizeChange"
                   @current-change="handleCurrentChange"
                   :current-page="pageNum"
                   :page-sizes="pageData.pageSizes || [10,50,100,500]"
                   :page-size="pageSize"
                   layout="total, sizes, prev, pager, next, jumper"
                   :total="total"
    >
    </el-pagination>
  </div>
</template>

<script>
import Qs from 'qs'

export default {
  props: ['pageData','className'],
  data() {
    return {
      tableKey: 1,
      tableData: [],
      total: this.pageData.size || 50,//初始总数
      pageSize: this.pageData.size || 10,//初始页面条数
      pageNum: 1,//当前页
      option: {},
      checkList: [],
      clientWidth: 0,
      loading: false
    }
  },
  mounted() {
    if (this.pageData.checkList) this.checkList = this.common.copy(this.pageData.checkList)
    this.clientWidth = document.body.clientWidth * 0.8
  },
  computed: {
    isShow: {
      get() {
        let showObj = {}
        for (let i in this.pageData.cols) {
          let title = this.pageData.cols[i].title
          if (this.checkList.indexOf(title) > -1) {
            showObj[title] = 'show'
          } else {
            showObj[title] = 'hide'
          }
        }
        return showObj
      }
    }
  },
  methods: {
    getStatusText(col,row) {
      const value = row[col.field];
    // 如果列配置了 tooltipFormatter，使用它
    if (col.tooltipFormatter) {
        return col.tooltipFormatter(value, row);
    }
    // 如果列配置了 activeText/inactiveText，使用它们
    if (col.activeText || col.inactiveText) {
        return `当前状态: ${value === '1'||value == 1 ? col.activeText : col.inactiveText}`;
    }
    // 默认处理
    return `当前状态: ${value === '1'||value == 1 ? '启用' : '禁用'}`;
         
     },
    //用户查询按钮调用
    defaultGetData(option, search=false) {
      if (search) this.pageNum = 1
      this.initData(this.pageData.queryUrl, option)
    },
    //用户查询按钮调用
    initData(queryUrl, option) {
      if (!option) option = {}
      this.option = option
      this.getData(queryUrl, !this.pageData.isPage ? { pageNum: this.pageNum, pageSize: this.pageSize } : {})
    },
    //调用后台接口获取数据
    getData(queryUrl, option) {
      this.loading = true;
      option = Object.assign(this.option, option)
      option = option || {}
      if (!this.pageData.method || this.pageData.method == 'post') {
        this.$axios.post(queryUrl, Qs.stringify(option)).then(res => {
          if (this.pageData.isPage == null || this.pageData.isPage) {
            this.total = Number(res.result.total)
            this.tableData = res.result.list
          } else {
            this.tableData = res.result
          }
          this.$emit('getTableData', this.tableData)
        }).finally(() => {
            this.loading = false
        });
      } else if (this.pageData.method == 'post-json') {
        this.$axios.post(queryUrl, option, {
          headers: {
            'isAjax': 'true',
            'Content-Type': 'application/json'
          }
        }).then(res => {
          if (this.pageData.isPage == null || this.pageData.isPage) {
            this.total = Number(res.result.total)
            this.tableData = res.result.list
          } else {
            this.tableData = res.result
          }
          this.$emit('getTableData', this.tableData)
        }).finally(() => {
            this.loading = false
        });
      } else {
        this.$axios.get(queryUrl, { params: option }).then(res => {
          if (this.pageData.isPage == null || this.pageData.isPage) {
            this.total = Number(res.result.total)
            this.tableData = res.result.list
          } else {
            this.tableData = res.result
          }
          this.$emit('getTableData', this.tableData)
        }).finally(() => {
            this.loading = false
        });
      }
    },
    pageGetData() {
      this.getData(this.pageData.queryUrl, { pageNum: this.pageNum, pageSize: this.pageSize })
    },
    //自定义点击事件(click:事件名)
    btnclick(col, row) {
      let clickName = col.click || col.h5Click
      console.log("======="+clickName);
      console.log(JSON.parse(JSON.stringify(row)));
      if (clickName === 'cancelTask') {
        this.$prompt('请输入取消原因', '取消？', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          beforeClose: (action, instance, done) => {
            if (action === 'confirm') {
              // 只有取消任务提案时取消原因才必填
              if (!instance.inputValue && row.bigTaskId) {
                this.$message.error('请输入取消原因');
                return false;
              }
              done();
            } else {
              done();
            }
          }
        }).then(({ value }) => {
          const addReason = {...row, reason: value};
          this.$emit('btnclick', col.click || col.h5Click, addReason);
        }).catch(() => {
        });
      } else if (clickName === 'del_product') {
        this.$confirm("请确定产品"+ row["enName"] +"无持仓或挂单数据？", "提示", {
          confirmButtonText: window.$t('page.enter'),
          cancelButtonText: window.$t('page.cancel'),
          type: 'warning'
        }).then(() => {
          this.confirm(col, row)
        }).catch(() => {
          
        });
      } else if (clickName === 'product_status') {
        if (row["isDelete"] === 1) {
          this.confirm(col, row);
        } else {
          let oldValue = row[col.field] === 1 ? 2 : 1;
          this.$confirm("请确定产品"+ row["enName"] +"无持仓或挂单数据？", "提示", {
            confirmButtonText: window.$t('page.enter'),
            cancelButtonText: window.$t('page.cancel'),
            type: 'warning'
          }).then(() => {
            this.confirm(col, row)
          }).catch(() => {
            row[col.field] = oldValue;
          });
        }
      } else if (clickName.indexOf('delete') > -1
       || clickName.indexOf('approved') > -1
       || clickName.indexOf('cancel') > -1
       || clickName.indexOf('status') > -1
       || clickName.indexOf('repeat') > -1
       || clickName.indexOf('disable') > -1
       || clickName.indexOf('unlock') > -1
       || clickName.indexOf('logout') > -1
       || clickName.indexOf('redo') > -1
       || clickName.indexOf('recommend') > -1
       || clickName.indexOf('back') > -1
       || clickName.indexOf('top') > -1
       || col.confirm) {
        this.confirm(col, row)
      } else {
        if (this.className === "米星卡等级") {
          this.$emit('btnclick', clickName, JSON.parse(JSON.stringify(row)), this.tableData.map(item => ({
              id: item.id,
              grade: item.grade,
              scoreRangeBegin: item.scoreRangeBegin,
              scoreRangeEnd: item.scoreRangeEnd,
              conditionAppr: item.conditionAppr,
              isDelete: item.isDelete,
              conditionPer: item.conditionPer
            }))
          )
        } else {
          this.$emit('btnclick', clickName, JSON.parse(JSON.stringify(row)))
        }
      }
      
  },
    confirm(col, row) {
      let name = col.field ? col.field : ((typeof col.name == 'function' ? col.name(row[col.field], row) : col.name))
      let notice = (!col.notice || col.notice == '') ? name : (typeof col.notice == 'function' ? col.notice(row[col.field], row) : col.notice)
      let oldValue = row[col.field] === 1 ? 2 : 1;
      this.$confirm(window.$t('page.confirm') + notice + window.$t('page.opertion'), notice, {
        confirmButtonText: window.$t('page.enter'),
        cancelButtonText: window.$t('page.cancel'),
        type: 'warning'
      }).then(() => {
        this.$emit('btnclick', col.click || col.h5Click, row)
      }).catch(() => {
        row[col.field] = oldValue;
      });
    },
    //多选数据处理
    checkbox(val) {
      this.$emit('checkbox', JSON.parse(JSON.stringify(val)))
    },
    //监听分页条数变化
    handleSizeChange(val) {
      this.pageSize = val
      this.pageGetData()
    },
    //监听分页页数变化
    handleCurrentChange(val) {
      this.pageNum = val
      this.pageGetData()
    },
    forceRerender() {
      this.tableKey++;
    }
  }
}
/* 插件使用说明
<Page ref="childTable" @checkbox=checkbox :pageData="pageData" @btnclick="btnclick(actName,row)"></Page>
pageData:初始化数据，btnclick(actName,row){}:获取操作数据按钮actName:事件名称,row选中的数据，checkBox(val){}:获取多选数据
methods: {
  //用于接收类别中声明的点击事件，clickName（声明的事件名称），row(点击事件携带的对象数据)
  bthClick (clickName, row) {},
  //勾选的数据可以在此处接收到
  checkbox (row) {}
},
data(){
   return{
       pageData: {
           queryUrl: "/mis/ValidateCodeLog/pageList",//请求路径和参数
           initOption:{},//初始请求参数，初始化无请求参数的话可以不声明此属性
           //是否开启多选框
           selection: false,
           //是否显示序号
           sequence:true,
           //列表(title:表头名称，file:字段属性名称，render:数据格式化或者做相关的逻辑处理（data:当前字段的值，full:当前数据对象），click:添加点击事件btnclick(col,row)，btnClick：可点击按钮,fixed:固定（elemnet-ui属性），overflow:内容过长隐藏策略),minWidth:最新宽度,show:hide可以因此此列相间在展示
           cols: [
             {title: "日期", field: "mobilePhone",fixed:false,overflow:true,render:(data,full)=>{
                     return data == 1?"开启":"关闭";
                 }},
             {title: "名称", field: "id"},
             {title: "省份", field: "code"},
             {title: "城市", field: "status"},
              //单事件操作，按钮样式定义请参考element,click:事件名称（会自动添加点击事件，bthClick事件会自动接收到此事件),auth（按钮权限）field：按钮名称,type:按钮类型(参考element-ui) icon：(按钮图标)参考element-ui,size(按钮大小，参考element-ui)
             {title:"操作",field:"修改",click:"update",width:150,auth:"",name:"删除"},
             //多事件操作，name：按钮名称 click：事件名称 type:按钮类型(参考element-ui) icon：(按钮图标)参考element-ui 默认添加点击事件btnclick(col,row){}  click:事件名称，row：当前行的数据  auth:权限，size(按钮大小，参考element-ui)
             {title:"操作",btnClick:[{name:"删除",auth:"card:bank:update",click:"delete",type:"primary",icon:"el-icon-delete"},{name:"修改",click:"modify",type:rimary",icon: "el-icon-edit"}]},
           ],
       }
   }
},
*/
</script>

